import React from 'react';
import PropTypes from 'prop-types';

function ISYoutubeV2({ to, className }) {
  return (
    <a className={className} target={`_blank`} rel="noopener noreferrer" href={to}>
      <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19.8008 6.56492C19.8008 6.56492 19.6055 5.18601 19.0039 4.58054C18.2422 3.78367 17.3906 3.77976 17 3.73289C14.2031 3.52976 10.0039 3.52976 10.0039 3.52976H9.99609C9.99609 3.52976 5.79688 3.52976 3 3.73289C2.60938 3.77976 1.75781 3.78367 0.996094 4.58054C0.394531 5.18601 0.203125 6.56492 0.203125 6.56492C0.203125 6.56492 0 8.18601 0 9.8032V11.3188C0 12.936 0.199219 14.5571 0.199219 14.5571C0.199219 14.5571 0.394531 15.936 0.992187 16.5415C1.75391 17.3384 2.75391 17.311 3.19922 17.397C4.80078 17.5493 10 17.5962 10 17.5962C10 17.5962 14.2031 17.5884 17 17.3891C17.3906 17.3423 18.2422 17.3384 19.0039 16.5415C19.6055 15.936 19.8008 14.5571 19.8008 14.5571C19.8008 14.5571 20 12.9399 20 11.3188V9.8032C20 8.18601 19.8008 6.56492 19.8008 6.56492ZM7.93359 13.1587V7.53757L13.3359 10.3579L7.93359 13.1587Z" fill="#5A5A5A"/>
      </svg>
    </a>
  )
}


ISYoutubeV2.propTypes = {
  to: PropTypes.string.isRequired,
  className: PropTypes.string,
}

export default ISYoutubeV2;
